import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "../pages/login";
import Dashboard from "../pages/Dashboard";
import Users from "../pages/Users";
import Analytics from "../pages/Analytics";
import Settings from "../pages/Settings";
import Reports from "../pages/Reports";
import AddUnit from "../pages/AddUnit";
import AddCategory from "../pages/AddCategory";
import CategoryList from "../pages/CategoryList";
import AddUser from "../pages/AddUser";
import UserList from "../pages/UserList";
import NotFound from "../pages/NotFound";
import UnitList from "../pages/UnitList";
import AddTable from "../pages/AddTable";
import TableList from "../pages/TableList";
import AddChair from "../pages/AddChair";
import ChairList from "../pages/ChairList";
import AddMenu from "../pages/AddMenu";
import MenuList from "../pages/MenuList";
import AddRoomType from "../pages/AddRoomType";
import RoomTypeList from "../pages/RoomTypeList";
import AddProduct from "../pages/AddProduct";
import ProductList from "../pages/ProductList";
import Layout from "../components/Layout";
import AddDepartment from "../pages/AddDepartment";
import DepartmentList from "../pages/DepartmentList";
import DepartmentCustomerList from "../pages/DepartmentCustomerList";
import AddDepartmentCustomer from "../pages/AddDepartmentCustomer";
import AddDepartmentDiscount from "../pages/AddDepartmentDiscount";
import DepartmentDiscountList from "../pages/DepartmentDiscountList";
import RoomAdd from "../pages/RoomAdd";
import RoomList from "../pages/RoomList";
import BedList from "../pages/BedList";
import AddBed from "../pages/AddBed";
import AddRoomBooking from "../pages/AddRoomBooking";
import RoomBookingList from "../pages/RoomBookingList";
import AddSupplier from "../pages/AddSupplier";
import Supplierlist from "../pages/Supplierlist";
import AddPurchase from "../pages/AddPurchase";
import PurchaseList from "../pages/PurchaseList";
import AddSale from "../pages/AddSale";
import SaleHistory from "../pages/SaleHistory";
import AddAsset from "../pages/AddAsset";
import AssetList from "../pages/AssetList";
import AddExpense from "../pages/AddExpense";
import ExpenseList from "../pages/ExpenseList";
import SupplierPayment from "../pages/SupplierPayment";
import SupplierPaymentHistory from "../pages/SupplierPaymentHistory";
import SalesReport from "../pages/SalesReport";
import SupplierReport from '../pages/SupplierReport';
import SalesReportNew from "../pages/SalesReportNew";
import PurchaseReport from "../pages/PurchaseReport";
import RoomBookingReport from "../pages/RoomBookingReport";
import EditPurchase from "../pages/EditPurchase";

// Protected Route Component
const ProtectedRoute = ({ children, isAuthenticated }) => {
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Public Route Component (redirects to dashboard if already authenticated)
const PublicRoute = ({ children, isAuthenticated }) => {
  return isAuthenticated ? <Navigate to="/dashboard" replace /> : children;
};

const AppRouter = ({ isAuthenticated, onLogout }) => {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route
          path="/login"
          element={
            <PublicRoute isAuthenticated={isAuthenticated}>
              <Login />
            </PublicRoute>
          }
        />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <Users />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/analytics"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <Analytics />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <Settings />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/reports"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <Reports />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-unit"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddUnit />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/edit-unit/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddUnit />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/unit-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <UnitList />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-category"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddCategory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-category/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddCategory />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/category-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <CategoryList />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-user"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddUser />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-user/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddUser />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/user-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <UserList />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-table"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddTable />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/table-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <TableList />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-chair"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddChair />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/chair-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <ChairList />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-menu"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddMenu />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/menu-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <MenuList />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-room-type"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddRoomType />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-room-type/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddRoomType />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/room-type-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <RoomTypeList />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/add-product"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddProduct />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-product/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddProduct />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/product-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <ProductList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-department"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddDepartment />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-department/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddDepartment />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/department-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <DepartmentList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/department-customer-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <DepartmentCustomerList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-department-customer"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddDepartmentCustomer />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-department-customer/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddDepartmentCustomer />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-department-discount"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddDepartmentDiscount />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-department-discount/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddDepartmentDiscount />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/department-discount-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <DepartmentDiscountList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-room"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <RoomAdd />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-room/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <RoomAdd />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/room-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <RoomList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/bed-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <BedList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-bed"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddBed />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-room-booking"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddRoomBooking />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-booking/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddRoomBooking />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/room-booking-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <RoomBookingList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-supplier"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddSupplier />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-supplier/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddSupplier />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/supplier-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <Supplierlist />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/supplier-payment/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <SupplierPayment />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/supplier-payment-history/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <SupplierPaymentHistory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-purchase"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddPurchase />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-purchase/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <EditPurchase />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <PurchaseList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-sale"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddSale />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sale-history"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <SaleHistory />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-asset"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddAsset />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-asset/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddAsset />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/asset-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AssetList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-expense"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddExpense />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-expense/:id"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <AddExpense />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/expense-list"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <ExpenseList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales-report"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <SalesReport />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales-report-new"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <SalesReportNew />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/supplier-report"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <SupplierReport />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/supplier-report/:supplierId"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <SupplierReport />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase-report"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <PurchaseReport />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/room-booking-report"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Layout onLogout={onLogout}>
                <RoomBookingReport />
              </Layout>
            </ProtectedRoute>
          }
        />

        {/* Default redirects ---------------------------- */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* 404 Not Found */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
